import { CourseElementType } from "./CourseElementType";
// import { ChatServices, TranscriptionServices } from "./CustomizationVm";
import { ExType } from "./ExType";

export interface ExTypeItem {
  value: ExType;
  label: string;
  icon: string;
}

export const exTypeItems: ExTypeItem[] = [
  // { value: ExType.Undefined, label: 'Undefined', icon: 'mdi-help-circle-outline' },
  // { value: ExType.Rule, label: 'Erklärung', icon: 'mdi-information-variant' },
  { value: ExType.Explanation, label: 'Kapitel', icon: 'mdi-playlist-play' },
  { value: ExType.ExplanationVideo, label: 'Video', icon: 'mdi-filmstrip' },
  { value: ExType.Exercise, label: 'Übung', icon: 'mdi-dumbbell' },
  { value: ExType.Test, label: 'Test', icon: 'mdi-flag-checkered' },
  { value: ExType.Scorm, label: 'SCORM Schulung', icon: 'mdi-book-open-page-variant' },
  { value: ExType.ManualApproval, label: 'Manuelle Schulungsfreigabe', icon: 'mdi-check-decagram-outline' },
  { value: ExType.ModuleApproval, label: 'Modul-Freigabe', icon: 'mdi-account-lock' },
  { value: ExType.Signature, label: 'Unterschrift', icon: 'mdi-signature-freehand' },
  { value: ExType.Survey, label: 'Umfrage', icon: 'mdi-account-question' },
];

export interface CourseElementTypeItem {
  value: CourseElementType;
  label: string;
  icon: string;
}

export const courseElementTypeItems: CourseElementTypeItem[] = [
  { value: CourseElementType.MdText, label: 'Markdown Text', icon: 'mdi-file-document' },
  { value: CourseElementType.Text, label: 'Text / HTML', icon: 'mdi-text' },
  { value: CourseElementType.SequentialList, label: 'Interaktive Liste', icon: 'mdi-format-list-bulleted' },
  { value: CourseElementType.FlipCardList, label: 'Flip Card Liste', icon: 'mdi-cards' },
  { value: CourseElementType.Pdf, label: 'PDF Dokument', icon: 'mdi-file-pdf-box' },
  { value: CourseElementType.Image, label: 'Bild', icon: 'mdi-image' },
  { value: CourseElementType.HeroHeadline, label: 'Hero Headline', icon: 'mdi-star' },
  { value: CourseElementType.Audio, label: 'Audio', icon: 'mdi-music' },
  { value: CourseElementType.TtsAudio, label: 'TTS Audio', icon: 'mdi-account-voice' },
  { value: CourseElementType.TtsSpeak, label: 'TTS Reader', icon: 'mdi-account-voice' },
  { value: CourseElementType.AudioPodcast, label: 'Audio Podcast', icon: 'mdi-microphone' },
  { value: CourseElementType.Video, label: 'Video', icon: 'mdi-filmstrip' },
  { value: CourseElementType.SingleChoice, label: 'Single Choice', icon: 'mdi-radiobox-marked' },
  { value: CourseElementType.MultipleChoice, label: 'Multiple Choice', icon: 'mdi-help-circle' },
  { value: CourseElementType.Slider, label: 'Schieberegler', icon: 'mdi-tune-variant' },
  { value: CourseElementType.Rating, label: 'Bewertung', icon: 'mdi-star' },
  { value: CourseElementType.Comment, label: 'Kommentar', icon: 'mdi-comment-text-outline' },
  { value: CourseElementType.Scorm, label: 'SCORM Schulung', icon: 'mdi-book-open-page-variant' },
  { value: CourseElementType.Signature, label: 'Unterschrift', icon: 'mdi-signature-freehand' },
];